import React from "react";
import PropTypes from "prop-types";

/**
 * Kontener zawierajacy pozycje nawigacji
 */
class NavBar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            /**
            * {number} index aktywnej pozycji
            */
            activeItemIndex: this.props.defaultActiveItemIndex
        };
    }

    /**
   * Obsługa klikniecia na wybany tab
   * 
   * @param {number} itemIndex - index pozycji która została kliknieta (numeracja od 0)
   */
    handleItemClick = (itemIndex) => {
        this.setState({
            activeItemIndex: itemIndex
        })
    }

    /**
   * Renderuje wszyskie pozycje wraz z zawartością
   */
    renderItems() {
        //pozycje nawigacji
        const { children } = this.props;
        //przechodzimy przez wszystkie pozycje i nadajemy lub nadpisujemy propertki
        return React.Children.map(children, (child, index) => {
            return React.cloneElement(child, {
                /**
                 * nadajemy index elementowi
                 */
                index: index,
                /**
                 * nadajemy funkcje onClick, która oznacza element jako aktywny - tylko ten
                 */
                onClick: this.handleItemClick,
                /**
                 * określamy czy właśnie ten element jest aktywny
                 */
                isActive: this.state.activeItemIndex === index
            });
        })
    }

    render() {
        return (
            <nav className={this.props.className}>
                {this.renderItems()}
            </nav>
        )
    }
}

NavBar.propTypes = {
    /**
     * Określa index pozycji - wybranej domyślnie
     */
    defaultActiveItemIndex: PropTypes.number,
    /**
     * Główna klasa css komponentu
     */
    className: PropTypes.string.isRequired,
    /**
   * Dzieci, czyli pojedyncze elementy Nawigacji. Jesli jest wiecej elementów - to dzieci są tablicą, jesli nie to jest pojedyńczy element.
   * Dzieci są wymagane, ponieważ określenie elementy Nawigacji, bez żadnej pozycji nie mają sensu
   */
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
};

NavBar.defaultProps = {
    /**
     * Określa index pozycji - wybranej domyślnie - numeracja automatyczna od 0, czyli zaznaczamy pierwszy element
     */
    defaultActiveItemIndex: 0
};

export default NavBar;